import { ApiClient } from '@k2/common/backend/api-client';

export class AssignmentServiceInvoiceEndpoint {
  constructor(private api: ApiClient) {

  }

  listCreditNotes = (assignmentServiceInstanceId: number, assignmentServiceInvoiceId: number) => {
    return this.api.getWithoutCache(`/assignment-service-instance/${assignmentServiceInstanceId}/assignment-service-invoice/${assignmentServiceInvoiceId}/credit-note`);
  };

  createCreditNote = (assignmentServiceInstanceId: number, assignmentServiceInvoiceId: number, data) => {
    return this.api.post(`/assignment-service-instance/${assignmentServiceInstanceId}/assignment-service-invoice/${assignmentServiceInvoiceId}/credit-note`, data);
  };
}
